import { combineReducers } from 'redux';

import shadows from './shadows/reducer';
import shadowSort from './shadow_sort/reducer';

const nullReducer = state => state == null ? {} : state;

export default combineReducers({
  canExportShadows: nullReducer,
  context: nullReducer,
  features: nullReducer,
  grids: nullReducer,
  shadows,
  shadowSort,
  urls: nullReducer,
});
